import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import Conditional from '@next-app/components/Conditional';
import Image from 'next/image';
import LLRadioAccordion from '@next-app/components/elements/LLRadioAccordion/LLRadioAccordion';
import {
  selectDisablePaymentList,
  selectIsPaymentMethodStep,
  selectOrderSummaryInfo,
  selectPaymentsInfo,
} from '@next-app/lib/features/checkout/CheckoutSelector';
import GiftCardForm from '../GiftCardForm/GiftCardForm';
import GiftCardsList from '../GiftCardsList/GiftCardsList';
import {
  getFormattedPrice,
  isNotEmptyObject,
} from '@next-app/utils/common-utils';

const GiftCardContainer = () => {
  // selectors
  const isPaymentMethodStep = useSelector(selectIsPaymentMethodStep);
  const disablePaymentList = useSelector(selectDisablePaymentList);
  const { showGiftCertificateAmount, giftCertificateAmount } =
    useSelector(selectOrderSummaryInfo) || {};
  const { profileGiftcards, giftCardsTotalAmount, giftCertificates } =
    useSelector(selectPaymentsInfo) || {};

  // local state
  const [showCollapsed, setShowCollapsed] = useState(true);

  // Renderers
  const RenderGiftCardHeader = useCallback(() => {
    return (
      <div style={{ marginLeft: '-4px' }}>
        <Image
          src="/react/assets/icons/gift-card.svg"
          alt="Gift Card icon"
          unoptimized={true}
          width={48}
          height={25}
        />
        <Conditional
          if={!showGiftCertificateAmount && !isNotEmptyObject(profileGiftcards)}
        >
          <span>Have a Gift Card?</span>
        </Conditional>
        <Conditional
          if={showGiftCertificateAmount || isNotEmptyObject(profileGiftcards)}
        >
          <span>
            Gift Cards -{' '}
            <strong>
              {`${showGiftCertificateAmount ? `${giftCertificateAmount} applied` : giftCardsTotalAmount ? `${getFormattedPrice(giftCardsTotalAmount)} in Available Gift Cards` : ''}`}{' '}
            </strong>
          </span>
        </Conditional>
      </div>
    );
  }, [showGiftCertificateAmount, giftCertificateAmount]);

  // methods
  const handleToggle = () => {
    setShowCollapsed((prev) => !prev);
  };

  const disableGiftCard =
    disablePaymentList &&
    giftCertificates?.length === 0 &&
    profileGiftcards?.length === 0;

  return (
    <>
      <Conditional if={isPaymentMethodStep}>
        <div className="my-ll-3">
          <LLRadioAccordion
            checked={true}
            isEditable={true}
            isExpanded={!showCollapsed}
            showRadioButton={false}
            onToggle={handleToggle}
            disabled={disableGiftCard}
            customClass={`${!showCollapsed ? 'rounded-top' : 'rounded'}`}
          >
            <RenderGiftCardHeader />
          </LLRadioAccordion>

          <Conditional if={!showCollapsed}>
            <div className="p-ll-3 border rounded-bottom bg-light">
              <Conditional
                if={
                  !showGiftCertificateAmount &&
                  !isNotEmptyObject(profileGiftcards)
                }
              >
                <GiftCardForm
                  setShowCollapsed={setShowCollapsed}
                  collapseOnSubmit={false}
                />
              </Conditional>

              <Conditional
                if={
                  showGiftCertificateAmount ||
                  isNotEmptyObject(profileGiftcards)
                }
              >
                <GiftCardsList />
              </Conditional>
            </div>
          </Conditional>
        </div>
      </Conditional>
    </>
  );
};

export default GiftCardContainer;
